import { Component } from '@angular/core';

@Component({
  selector: 'app-medicine-icon',
  imports: [],
  templateUrl: './medicine-icon.html',
  styleUrl: './medicine-icon.scss'
})
export class MedicineIcon {

}
